/* ab-motion.js · ActiveBeyond40 scroll motion engine (≈2.5 KB, no dependencies).
   Compositor-safe: only transform/opacity are animated. Honours prefers-reduced-motion.
   Hooks (data attributes):
     data-ab-reveal            → adds .is-in when 12% visible; [data-ab-stagger] children get --i
     data-ab-parallax="0.12"   → translateY drift relative to viewport centre (speed = factor)
     data-ab-progress          → sets --p (0→1) as the element travels from viewport bottom to centre
     data-ab-marquee           → duplicates the track once for a seamless CSS loop
*/
(function () {
  if (window.__abMotion) return; window.__abMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document;

  function stagger(root) {
    var kids = root.querySelectorAll('[data-ab-stagger]');
    for (var i = 0; i < kids.length; i++) kids[i].style.setProperty('--i', String(i));
  }

  function init(scope) {
    scope = scope || doc;
    /* marquee: clone track content once */
    var mq = scope.querySelectorAll('[data-ab-marquee]:not([data-ab-ready])');
    for (var m = 0; m < mq.length; m++) {
      var track = mq[m].querySelector('.ab-marquee__track');
      if (track) { track.insertAdjacentHTML('beforeend', track.innerHTML); }
      mq[m].setAttribute('data-ab-ready', '1');
    }
    /* reveals */
    var rev = scope.querySelectorAll('[data-ab-reveal]:not([data-ab-ready])');
    for (var r = 0; r < rev.length; r++) {
      stagger(rev[r]); rev[r].setAttribute('data-ab-ready', '1');
      if (reduce || !('IntersectionObserver' in window)) { rev[r].classList.add('is-in'); } else { io.observe(rev[r]); }
    }
    /* parallax + progress */
    var px = scope.querySelectorAll('[data-ab-parallax]:not([data-ab-ready]), [data-ab-progress]:not([data-ab-ready])');
    for (var p = 0; p < px.length; p++) {
      px[p].setAttribute('data-ab-ready', '1');
      if (reduce) { px[p].style.setProperty('--p', '1'); continue; }
      tracked.push(px[p]); vis.observe(px[p]);
    }
    /* warm product-card hover images so the crossfade has no network lag */
    var warm = function(){ var hv=doc.querySelectorAll('.m-product-card__hover-image img:not([data-ab-warm])');
      for (var w=0; w<hv.length; w++){ hv[w].setAttribute('data-ab-warm','1'); try{ hv[w].loading='eager'; if(hv[w].dataset && hv[w].dataset.src && !hv[w].src){ hv[w].src=hv[w].dataset.src; } }catch(e){} } };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, {timeout: 1500}); else setTimeout(warm, 900);
    tick();
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { es[i].target.classList.add('is-in'); io.unobserve(es[i].target); }
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  var tracked = [], active = [], raf = 0;
  var vis = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      var el = es[i].target, idx = active.indexOf(el);
      if (es[i].isIntersecting) { if (idx < 0) active.push(el); } else if (idx > -1) { active.splice(idx, 1); }
    }
    /* warm product-card hover images so the crossfade has no network lag */
    var warm = function(){ var hv=doc.querySelectorAll('.m-product-card__hover-image img:not([data-ab-warm])');
      for (var w=0; w<hv.length; w++){ hv[w].setAttribute('data-ab-warm','1'); try{ hv[w].loading='eager'; if(hv[w].dataset && hv[w].dataset.src && !hv[w].src){ hv[w].src=hv[w].dataset.src; } }catch(e){} } };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, {timeout: 1500}); else setTimeout(warm, 900);
    tick();
  }, { rootMargin: '20% 0px 20% 0px' }) : null;

  function tick() { if (!raf) raf = requestAnimationFrame(update); }
  function update() {
    raf = 0;
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    for (var i = 0; i < active.length; i++) {
      var el = active[i], rect = el.getBoundingClientRect();
      var f = parseFloat(el.getAttribute('data-ab-parallax'));
      if (!isNaN(f)) {
        var d = (rect.top + rect.height / 2) - vh / 2;   /* px from viewport centre */
        el.style.transform = 'translate3d(0,' + (-d * f).toFixed(1) + 'px,0)';
      }
      if (el.hasAttribute('data-ab-progress')) {
        var mode = el.getAttribute('data-ab-progress');
        var pr = mode === 'line' ? (vh * 0.62 - rect.top) / rect.height : mode === 'enter' ? (vh - rect.top) / Math.min(rect.height, vh * 0.45) : (vh - rect.top) / (vh / 2 + rect.height / 2);
        pr = pr < 0 ? 0 : pr > 1 ? 1 : pr;
        el.style.setProperty('--p', pr.toFixed(3));
      }
    }
  }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  /* Shopify theme editor: re-init on section load */
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.abMotionInit = init;
})();
